import { REDUX } from 'constants/'
import { 
    AuthenticationReducerTypeInitiator, 
    AuthenticationAction, 
    AuthenticationReducer } from 'types/autentication'
  /**
   * Reducer para objeto notification
   * @param state 
   * @param action 
   */
  const AuthenticationReducers = (state = AuthenticationReducerTypeInitiator, action:AuthenticationAction):AuthenticationReducer => {
    switch (action.type) {
        case REDUX.reducers.GET_USER_BY_ACCOUNT_NAME:
            return { ...state, dataGraph: action.payload, error: false, loading: false } as AuthenticationReducer  
        case REDUX.reducers.SET_AZURE_TOKEN:
            return { ...state, dataAzure: action.payload, azureAccessTokenExpired: false, messageAuthentication: null, error: false, loading: false } as AuthenticationReducer
        case REDUX.reducers.SET_USER_TOKEN:
            return { ...state, dataJwt: action.payload, jwtAccessTokenExpired: false, messageAuthentication: null, error: false, loading: false } as AuthenticationReducer
        case REDUX.reducers.GET_AUTHENTICATED_USER:
            return { ...state, dataGraph: [action.payload], error: false, loading: false } as AuthenticationReducer
        case REDUX.reducers.ERROR_AUTHENTICATION:
            return { ...state, dataGraph:[], messageAuthentication: action.payload, error: true, loading: false } as AuthenticationReducer
        case REDUX.reducers.SET_AZURE_TOKEN_ACCESS_TOKEN_EXPIRED:
            return { ...state, azureAccessTokenExpired: action.payload, error: true, loading: false } as AuthenticationReducer
        case REDUX.reducers.SET_JWT_TOKEN_ACCESS_TOKEN_EXPIRED:
            return { ...state, jwtAccessTokenExpired: action.payload, error: true, loading: false } as AuthenticationReducer            
        case REDUX.reducers.SET_IS_AUTHENTICATED:
            return { ...state, isAutheticated: action.payload, error: true, loading: false } as AuthenticationReducer
        case REDUX.reducers.SET_SHOW_HEADER:
            return { ...state, showHeader: action.payload, error: true, loading: false } as AuthenticationReducer
        default:          
            return state
    }
  }

  export const thunkClearGraphDataAsync = () => {
    return (dispatch:any) => {
        dispatch({
            type: REDUX.reducers.GET_USER_BY_ACCOUNT_NAME,
            payload: []
        })
    }
  }
  
  export default AuthenticationReducers